import React from "react";
import styles from "./TemplateInput.module.scss";
import { FormControl, InputLabel, Select, SelectChangeEvent, MenuItem, TextField, StyledEngineProvider } from "@mui/material";
import { TemplateInterface } from "../../../../models/Template";

export interface RegisterDialogProps {
    template: string;
    setTemplate: Function;
    templateSubject: string;
    setTemplateSubject: Function;
    templateContent: string;
    setTemplateContent: Function;
    templates?: TemplateInterface[];
    mailType: string;
    name: string;
    emptyContentJson: string;
}

const TemplateInput: React.FC<RegisterDialogProps> = (props: RegisterDialogProps) => {

    return (
        <StyledEngineProvider injectFirst>
            <FormControl fullWidth className={styles.input}>
                <InputLabel>{props.name}</InputLabel>
                <Select
                    value={props.template}
                    label={props.name}
                    onChange={(event: SelectChangeEvent) => {
                        props.setTemplate(event.target.value as string)
                        if(!props.templates?.find(t => t.name == event.target.value)?.hasInputContentVariables) {
                            props.setTemplateSubject("")
                            props.setTemplateContent(props.emptyContentJson)
                        }
                    }}
                >
                    {props.templates?.filter(template => template.notificationType == props.mailType).map((template, index) => (
                        <MenuItem key={index} value={template.name}>{template.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {props.templates?.find(t => t.name == props.template)?.hasInputContentVariables &&
                <>
                    <TextField
                        className={styles.input}
                        label="Subject"
                        required
                        size="small"
                        value={props.templateSubject}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            props.setTemplateSubject(event.target.value);
                        }}
                    />
                    <TextField
                        className={styles.input}
                        label="Content"
                        required
                        multiline
                        size="small"
                        value={props.templateContent}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            props.setTemplateContent(event.target.value);
                        }}
                    />
                </>}
            </StyledEngineProvider>
    );
};


export default TemplateInput;